import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { createMmscanI18n, type MmscanI18nFactory } from '@mmscan/angular-ui/core';

/** Strings rendered by the rich-text editor. `{count}` / `{max}` are replaced in `characterCount`. */
export interface MmscanEditorI18n {
  toolbar: string;
  bold: string;
  italic: string;
  underline: string;
  strikethrough: string;
  heading2: string;
  heading3: string;
  numberedList: string;
  bulletList: string;
  quote: string;
  codeBlock: string;
  link: string;
  linkUrl: string;
  applyLink: string;
  removeLink: string;
  clearFormatting: string;
  characterCount: string;
}

export const MMSCAN_EDITOR_I18N_DEFAULTS: MmscanEditorI18n = {
  toolbar: 'Formatting',
  bold: 'Bold',
  italic: 'Italic',
  underline: 'Underline',
  strikethrough: 'Strikethrough',
  heading2: 'Heading',
  heading3: 'Subheading',
  numberedList: 'Numbered list',
  bulletList: 'Bulleted list',
  quote: 'Quote',
  codeBlock: 'Code block',
  link: 'Link',
  linkUrl: 'Link address',
  applyLink: 'Apply',
  removeLink: 'Remove link',
  clearFormatting: 'Clear formatting',
  characterCount: '{count} / {max}',
};

const editorI18n = createMmscanI18n<MmscanEditorI18n>('MMSCAN_EDITOR_I18N', MMSCAN_EDITOR_I18N_DEFAULTS);

export const MMSCAN_EDITOR_I18N = editorI18n.token;

export interface MmscanEditorOptions {
  /** Translated editor strings; same contract as `provideMmscanUi({ i18n })`. */
  i18n?: MmscanI18nFactory<MmscanEditorI18n>;
}

export function provideMmscanEditor(options: MmscanEditorOptions = {}): EnvironmentProviders {
  return makeEnvironmentProviders(options.i18n ? [editorI18n.provide(options.i18n)] : []);
}
